<template>
  <!-- 订单流水 -->
  <div class="order-water-container">
    <!-- 头部筛选 -->
    <div class="header-select">
      <div class="left" @click="handleSelectDateShow(true)">
        <span>{{
          search.allType
            ? `全部时间`
            : `${dateInfo.startTimeShow} ~ ${dateInfo.endTimeShow}`
        }}</span>
        <van-icon class="icon" name="play" />
      </div>
      <div class="right" @click="handleSelectScreenShow(true)">
        <span>筛选</span>
        <van-icon class="icon" name="play" />
      </div>
    </div>
    <!-- 主题信息 -->
    <div class="body-content">
      <van-list
        v-if="orderDatas.length"
        class="list"
        v-model="listLoging"
        @load="listLoad"
        :finished="finished"
        offset="20"
        finished-text="已获取全部数据"
      >
        <OrderList
          :isSubAccount="!!userInfo.isSubAccount"
          v-for="(item, index) in orderDatas"
          :dataList="item"
          :key="index"
        />
      </van-list>
      <van-empty
        v-else-if="orderDatas.length === 0 && !isLoading"
        description="暂无数据"
      />
    </div>

    <van-popup
      round
      v-model="selectDateShow"
      position="bottom"
      :style="{ height: 'auto' }"
    >
      <div class="date-container">
        <div class="title">
          <span>选择日期</span>
          <van-icon @click="handleSelectDateShow(false)" name="cross" />
        </div>
        <div class="main-content">
          <div
            class="allDate"
            @click="changeAllType()"
            :class="{ active: inputActiveClass === 1 }"
          >
            全部时间
          </div>
          <div class="diy">
            <div class="diy-text">自定义时间</div>
            <div class="selseDate">
              <div
                class="start"
                :class="{ active: inputActiveClass === 2 }"
                @click="dateMinShow()"
              >
                {{ dateInfo.startTimeShow }}
              </div>
              <span class="concat">~</span>
              <div
                class="end"
                :class="{ active: inputActiveClass === 3 }"
                @click="dateMaxShow()"
              >
                {{ dateInfo.endTimeShow }}
              </div>
            </div>
            <button @click="dateEnter" class="btn">确定</button>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="selectScreenShow"
      position="top"
      :style="{ height: 'auto' }"
    >
      <div class="screen-content">
        <div class="title">筛选</div>
        <div class="main-content">
          <van-cell-group>
            <van-field
              label="消费订单号："
              placeholder="请输入消费订单号"
              v-model.trim="search.odd"
            />
            <van-field
              label="顾客手机号："
              type="number"
              placeholder="请输入顾客手机号"
              v-model.trim="search.mobile"
            />
          </van-cell-group>

          <div class="input-item border">
            <div class="table">订单类型：</div>
            <div class="value">
              <Select
                bgColor="rgba(0,0,0,.15)"
                :valueList="[
                  { table: '请选择', value: -1 },
                  { table: '充值', value: 0 },
                  { table: '消费', value: 1 },
                ]"
                fontColor="#000"
                width="100px"
                v-model.trim="search.oddType"
              />
            </div>
          </div>
          <div class="input-item border" v-if="!userInfo.isSubAccount">
            <div class="table">导购：</div>
            <div class="value">
              <Select
                bgColor="rgba(0,0,0,.15)"
                fontColor="#000"
                :valueList="[{ table: '请选择', value: -1 }, ...shoppingList]"
                v-model="search.shopping"
              />
            </div>
          </div>
        </div>
        <div class="btns">
          <button @click="reset" class="rest">重置</button>
          <button @click="selectEnter" class="enter">确定</button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="dateInfo.minShow" position="bottom">
      <!-- 日期选择器 -->
      <van-datetime-picker
        @cancel="
          () => {
            dateInfo.minShow = false;
          }
        "
        type="date"
        title="选择年月日"
        v-model="dateInfo.currentDate"
        @confirm="handleDate"
        :max-date="dateInfo.maxDate"
      />
    </van-popup>
    <van-popup v-model="dateInfo.MaxShow" position="bottom">
      <!-- 日期选择器 -->
      <van-datetime-picker
        @cancel="
          () => {
            dateInfo.MaxShow = false;
          }
        "
        type="date"
        title="选择年月日"
        v-model="dateInfo.currentDate"
        @confirm="handleDateMax"
        :min-date="dateInfo.minDate"
        :max-date="dateInfo.maxDate"
      />
    </van-popup>
    <van-loading class="loading" v-show="isLoading" size="24px"
      >加载中...</van-loading
    >
  </div>
</template>

<script>
import moment from "moment";
import OrderList from "./components/OrderList";
import Select from "../../components/Select";
export default {
  name: "keepOrderWater",
  data() {
    return {
      isLoading: true,
      listLoging: false,
      finished: false,
      selectDateShow: false, //控制全部时间的显示
      selectScreenShow: false, //控制筛选
      userInfo: {}, //登录的用户信息
      inputActiveClass: 1,
      dateInfo: {
        //date弹出框信息
        currentDate: new Date(),
        maxDate: new Date(),
        minDate: new Date(),
        minShow: false,
        MaxShow: false,
        type: "",
        startTimeShow: "选择开始时间",
        endTimeShow: "选择结束时间",
        value: "",
      },
      load: {
        hasNext: null, //是否还有后续数据
        lastDate: null, //下一个月数据的时间
      },
      search: {
        //过滤信息
        startTime: "", //开始时间
        endTime: "", //结束时间
        odd: "", //单号
        allType: true, //全部时间
        mobile: "", //顾客手机号
        oddType: "", //订单类型
        shopping: "", //导购
        isRequest: {}, //记录点击的时候的筛选数据到结束的时候判断有没有改变 从而是否发送请求
      },
      shoppingList: [], //子账号列表
      orderDatas: [], //显示的列表数据
    };
  },
  async created() {
    let date = new Date();
    date.setFullYear(date.getFullYear() - 10);
    this.dateInfo.minDate = date;
    this.getUesrInfo();
    this.getChildrenList();
    this.getDateAll();
  },
  methods: {
    //获取子账号列表
    getChildrenList() {
      const data = {
        shopCode: this.userInfo.shopCode,
        accountId: this.userInfo.id,
      };
      const _this = this;
      this.$http
        .post("/api/storeSubbranch/querySubAccountList", data)
        .then((res) => {
          if (res.data.code === "0000") {
            _this.shoppingList = Object.freeze(
              res.data.data.results.map((item) => ({
                table: item.userName,
                value: item.id.toString(),
              }))
            );
          }
        });
    },
    //获取用户信息
    getUesrInfo() {
      const user = sessionStorage.getItem("shopInfo");
      this.userInfo = user ? JSON.parse(user) : {};
    },
    //点击的是全部时间
    changeAllType() {
      this.dateInfo.maxDate = new Date();
      let date = new Date();
      date.setFullYear(date.getFullYear() - 10);
      this.dateInfo.minDate = date;
      this.load.fist = true;
      this.finished = true;
      this.search.allType = !this.search.allType;
      if (this.inputActiveClass === 1) {
        this.inputActiveClass = 0;
      } else {
        this.inputActiveClass = 1;
      }
      this.dateInfo.startTimeShow = "选择开始时间";
      this.dateInfo.endTimeShow = "选择结束时间";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    //第一次获取全部数据
    async getDateAll() {
      const date = moment();
      const endTime = date.format("YYYY-MM-DD") + " " + "23:59:59";
      date.date(1);
      const startTime = date.format("YYYY-MM-DD");

      let result = await this.getData(startTime, endTime);
      if (result.orderFlowVos.length) {
        this.orderDatas = [
          ...Object.freeze(this.orderDataformat(result.orderFlowVos)),
        ];
      }
    },
    /**
     * startDate:开始时间
     * endDate:结束时间
     * 获取数据的函数
     */
    async getData(startDate, endDate) {
      const data = {}; //根据时间获取信息
      this.isLoading = true; //设置正在获取数据icon
      this.userInfo.isSubAccount
        ? (data.subbranchId = this.userInfo.id)
        : (data.shopCode = this.userInfo.shopCode); //根据是不是主账号设置请求值
      data.startTimeStart = startDate; //开始时间
      data.startTimeEnd = endDate; //结束时间
      this.search.mobile ? (data.mobile = this.search.mobile.trim()) : "";
      this.search.odd ? (data.orderName = this.search.odd.trim()) : "";
      this.search.oddType !== "" ? (data.orderType = this.search.oddType) : "";
      this.search.shopping !== ""
        ? (data.subbranchId = this.search.shopping.trim())
        : "";
      let result = await this.$http.post("/api/order/queryOrderFlow", data); //获取数据
      result = result.data;
      this.isLoading = false; //设置请求完毕icon
      if (result.code === "0000") {
        result = result.data.results;
        if (!result.hasNext) {
          //触底不在请求数据
          this.finished = true;
        }
        this.load.hasNext = result.hasNext;
        this.load.lastDate = result.lastDate;
        return result;
      }
    },
    // 格式化得到的数据
    orderDataformat(list) {
      list.forEach((item) => {
        item.consumptionTotal = Math.abs(item.consumptionTotal);
        item.monthShow = item.month.split("-")[1];
        const dayData = new Array(31);
        for (let i = 0; i < 32; i++) {
          dayData[i] = []; //31天
        }
        item.queryOrderFlowVoList.forEach((day) => {
          let date = moment(day.time);
          const index = date.date();
          day.time = date.format("HH:mm:ss");
          dayData[index].push(day);
        });
        item.queryOrderFlowVoList = dayData;
      });

      return list;
    },
    handleSelectDateShow(state) {
      this.selectDateShow = state;
      this.search.isRequest = { ...this.search }; //记录筛选前的状态
    },
    handleSelectScreenShow(state) {
      this.selectScreenShow = state;
      this.search.isRequest = { ...this.search }; //记录筛选前的状态
    },
    //弹出start隐藏时间选择器
    dateMinShow() {
      this.dateInfo.minShow = true;
      this.search.allType = false;

      this.inputActiveClass = 2;
      if (!this.search.startTime) {
        this.dateInfo.currentDate = new Date();
      } else {
        let searchStart = this.search.startTime.split("-");
        this.dateInfo.currentDate = new Date(
          searchStart[0],
          +searchStart[1] - 1,
          searchStart[2]
        );
      }
    },
    dateMaxShow() {
      this.dateInfo.MaxShow = true;
      this.search.allType = false;

      this.inputActiveClass = 3;
      if (!this.search.endTime) {
        this.dateInfo.currentDate = new Date();
      } else {
        let searchEnd = this.search.endTime.split("-");
        this.dateInfo.currentDate = new Date(
          searchEnd[0],
          +searchEnd[1] - 1,
          searchEnd[2]
        );
      }
    },
    //时间确定事件
    handleDate(value) {
      let date = moment(value).format("YYYY年MM月DD日");
      let searchDate = moment(value).format("YYYY-MM-DD");
      //根据type赋值
      this.dateInfo.startTimeShow = date;
      this.search.startTime = searchDate;
      this.dateInfo.minDate = new Date(value);

      this.dateInfo.minShow = false;
      this.dateInfo.minDate = new Date(value);
      return;
    },
    handleDateMax(value) {
      let date = moment(value).format("YYYY年MM月DD日");
      let searchDate = moment(value).format("YYYY-MM-DD");
      this.dateInfo.endTimeShow = date;
      this.search.endTime = searchDate + " " + "23:59:59";
      this.dateInfo.MaxShow = false;
    },
    //全部时间确定
    async dateEnter() {
      let result;
      if(this.search.allType === this.search.isRequest.allType && this.search.startTime === this.search.isRequest.startTime && this.search.endTime === this.search.isRequest.endTime){
        this.selectDateShow = false;
       return;//前后的数据一样 不发送请求
      }
      if (
        this.search.allType ||
        (this.search.startTime && this.search.endTime)
      ) {
        this.selectDateShow = false;
        if (this.search.allType) {
          this.isLoading = true;
          this.listLoging = false;
          this.finished = false;
          this.getDateAll();
          return;
        }
        this.selectDateShow = false;
        this.finished = true;
        //检查通过
        result = await this.getData(this.search.startTime, this.search.endTime);
        result = this.orderDataformat(result.orderFlowVos);
        this.orderDatas = [...Object.freeze(result)];
      } else {
        this.$toast("请选择时间");
      }
    },
    //重置
    reset() {
      this.search.odd = "";
      this.search.mobile = "";
      this.search.oddType = "";
      this.search.shopping = "";
    },
    //订单类型选择
    selectChangeOddType(value) {
      this.search.oddType = value;
    },
    //导购选择
    selectChangeDaoGou(value) {
      this.search.shopping = value;
    },
    //触底刷新
    async listLoad() {
      this.isLoading = true;
      let result;
      const date = moment(this.load.lastDate);
      let startTime, endTime;
      startTime = date.format("YYYY-MM") + `-01`;
      date.month(date.month() + 1);
      endTime = date.format("YYYY-MM") + "-01";
      +"-01";
      result = await this.getData(startTime, endTime);
      result = this.orderDataformat(result.orderFlowVos);
      this.orderDatas.push(result[0]);
    },
    //筛选的确定事件
    async selectEnter() {
      this.selectScreenShow = false;
      if (
        this.search.odd === this.search.isRequest.odd &&
        this.search.mobile === this.search.isRequest.mobile &&
        this.search.oddType === this.search.isRequest.oddType &&
        this.search.shopping === this.search.isRequest.shopping
      ) {
        return; //点击的前后 筛选的数据没有发生改变 就不发送请求数据
      }
      if (
        !this.search.odd &&
        !this.search.mobile &&
        !this.search.oddType &&
        !this.search.shopping &&
        this.search.allType
      ) {
        //发送获取全部的数据
        this.isLoading = true;
        this.listLoging = false;
        this.finished = false;
        this.getDateAll();
        return;
      }
      this.finished = false;
      let endTime = this.search.endTime + "23:59:59";
      let startTime = this.search.startTime;

      let result = await this.getData(startTime, endTime);
      this.orderDatas = [
        ...Object.freeze(this.orderDataformat(result.orderFlowVos)),
      ];
      this.finished = true;
    },
  },
  components: {
    OrderList,
    Select,
  },
};
</script>

<style lang="less" scoped>
@import url("~@/assets/css/order/orderWater.less");
</style>